import { combineReducers } from 'redux';
import languageProviderReducer from './containers/language-provider/reducer';
import masterCourseReducer from './containers/master-courses/reducer';
import defaultCourseReducer from './containers/default-courses/reducer';
import courseCreatorReducer from './containers/course-creator/reducer';
import toastReducer from './components/toast/reducer';
import setDefaultCoursesReducer from './containers/set-default-courses/reducer';
import authorizationReducer from './components/with-auth/reducer';

const reducers = combineReducers({
    product: state => ({ ...state }),
    language: languageProviderReducer,
    masterCourse: masterCourseReducer,
    courseCreator: courseCreatorReducer,
    defaultCourse: defaultCourseReducer,
    toast: toastReducer,
    setDefaultCourse: setDefaultCoursesReducer,
    authorization: authorizationReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./app/reducers.js